export enum QCImpactId {
  EXCLUDE = 'exclude',
  FLAGGED = 'flagged',
  USABLE = 'usable',
}

export interface QCLabel {
  id: string;
  name: string;
  description?: string;
  impactId: string;
  deletedAt?: string;
  deletedBy?: string;
}

export interface QCImpact {
  id: QCImpactId;
  name: string;
  description?: string;
}
